import { useRootScope } from 'FrontRoyalAngular';
import { RedirectWithTarget } from './RedirectWithTarget';

export function RedirectToSignIn() {
    const $rootScope = useRootScope();
    return <RedirectWithTarget to={$rootScope.postLogoutSignInPath} />;
}
